import { useQuery } from '@tanstack/react-query';
import type { QueryClient } from '@tanstack/react-query';
import { getAiUsage } from '../services/aiUsageService';
import type { AiUsageSummary } from '../services/aiUsageService';

export const AI_USAGE_QUERY_KEY = ['ai-usage'] as const;

/** Re-reads the AI credit meter (call after any AI request, successful or not). */
export function invalidateAiUsage(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ queryKey: AI_USAGE_QUERY_KEY });
}

export interface UseAiUsageResult {
  usage: AiUsageSummary | undefined;
  isLoading: boolean;
  error: unknown;
  retry: () => void;
  /** True when user-triggered AI features must be disabled. */
  exceeded: boolean;
}

export function useAiUsage(): UseAiUsageResult {
  const query = useQuery({
    queryKey: AI_USAGE_QUERY_KEY,
    queryFn: getAiUsage,
    staleTime: 60_000,
    retry: false,
  });
  return {
    usage: query.data,
    isLoading: query.isPending,
    error: query.error,
    retry: () => {
      void query.refetch();
    },
    exceeded: query.data?.exceeded === true,
  };
}
